import Vue from "vue";
import firebase from "firebase/app";
import { fetchWhoami } from "@/services/admin";

// Papel do usuário logado. Quem decide é o servidor (serviço jobs: ADMIN_EMAILS + token do Firebase);
// aqui a interface só mostra ou esconde as opções de administrador. Sem cluster (modo local) a rota
// não existe e todos são usuários comuns.
export const role = Vue.observable({ uid: null, isAdmin: false, checked: false });

let pending = null;

export function loadRole() {
  const user = firebase.auth().currentUser;
  if (!user) {
    Object.assign(role, { uid: null, isAdmin: false, checked: true });
    return Promise.resolve(role);
  }
  if (role.uid === user.uid && role.checked) return Promise.resolve(role);
  if (pending) return pending;
  pending = user
    .getIdToken()
    .then(token => fetchWhoami(token))
    .then(response => response.data && response.data.admin === true)
    .catch(() => false)
    .then(isAdmin => {
      Object.assign(role, { uid: user.uid, isAdmin, checked: true });
      pending = null;
      return role;
    });
  return pending;
}

// Cabeçalho com o login atual, para as rotas que o servidor só aceita de administradores
export async function authHeaders() {
  const user = firebase.auth().currentUser;
  return user ? { Authorization: `Bearer ${await user.getIdToken()}` } : {};
}
